import { InputLabel, Space } from '@procurify/ui'

import { PriceFormField } from '@webapp/components/PriceField'
import { CurrencySelect } from '@webapp/core/components/CurrencySelect'
import {
  type Currency,
  type CurrencyName,
} from '@webapp/core/entities/external/Currency'
import { useProcurifyIntl } from '@webapp/hooks'
import { TaxFields } from './TaxFields'
import messages from '../messages'

interface IDefaultFieldsProps {
  currencyName: CurrencyName
  selectedCurrency: Currency | null
  onCurrencyChange: (currency: Currency | null) => void
  isSubmitting: boolean
  canOverrideTaxAmount: boolean
}

export const DefaultFields = ({
  currencyName,
  selectedCurrency,
  onCurrencyChange,
  isSubmitting,
  canOverrideTaxAmount,
}: IDefaultFieldsProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space>
      <Space align='center' justify='end' direction='horizontal'>
        <InputLabel htmlFor='subtotal'>
          {intl.formatMessage(messages.subtotalLabel)}
        </InputLabel>
        <Space.Item width={1 / 3}>
          <PriceFormField
            id='subtotal'
            name='subtotal'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
        <Space.Item width={1 / 3}>
          <CurrencySelect
            inputId='defaultFields-currency-select'
            value={selectedCurrency}
            onChange={onCurrencyChange}
            isDisabled={isSubmitting}
            menuPortalTarget={document.body}
          />
        </Space.Item>
      </Space>

      <TaxFields
        isSubmitting={isSubmitting}
        canOverrideTaxAmount={canOverrideTaxAmount}
      />

      <Space align='center' direction='horizontal' justify='end'>
        <InputLabel>
          {intl.formatMessage(messages.totalWithCurrencyLabel, {
            currencyName,
          })}
        </InputLabel>
        <Space.Item width={1 / 3}>
          <PriceFormField
            id='totalCost'
            name='totalCost'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
      </Space>
    </Space>
  )
}
